var map = {
	"./bet-logo-9lotto.png": 726,
	"./bet-logo-big-cash.png": 727,
	"./bet-logo-damacai-inversed.png": 728,
	"./bet-logo-damacai.png": 729,
	"./bet-logo-gd.png": 730,
	"./bet-logo-gdlotto.png": 731,
	"./bet-logo-harihari.png": 732,
	"./bet-logo-magnum.png": 733,
	"./bet-logo-p8.png": 734,
	"./bet-logo-perdana.png": 735,
	"./bet-logo-sabah88.png": 736,
	"./bet-logo-singapore-pools.png": 737,
	"./bet-logo-stc.png": 738,
	"./bet-logo-toto-inversed.png": 739,
	"./bet-logo-toto.png": 740,
	"./gdlotto.png": 741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;